var _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#1C74D0",
    fillOpacity: 0.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_829_2537)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 20.0001,
    r: 15.381,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_2537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6563 14.3436C24.1488 12.8795 22.1257 12.0674 20.0243 12.0827C17.9229 12.0981 15.9119 12.9397 14.4259 14.4257C12.9399 15.9116 12.0983 17.9226 12.083 20.0241C12.0676 22.1255 12.8797 24.1486 14.3438 25.6561C15.3661 26.6771 16.6454 27.4027 18.0464 27.756C19.4473 28.1093 20.9178 28.0772 22.302 27.663C22.4996 27.6027 22.6652 27.4666 22.7628 27.2845C22.8603 27.1024 22.8817 26.889 22.8223 26.6912C22.763 26.4933 22.6276 26.327 22.446 26.2286C22.2643 26.1303 22.051 26.1079 21.8529 26.1664C21.2518 26.3465 20.6276 26.4378 20.0001 26.4373C16.4504 26.4373 13.5626 23.5495 13.5626 19.9998C13.5626 16.4502 16.4504 13.5623 20.0001 13.5623C23.5498 13.5623 26.4376 16.4502 26.4376 19.9998C26.4398 21.2546 26.0736 22.4825 25.3845 23.5311C25.2737 23.7042 25.2356 23.914 25.2785 24.115C25.3214 24.3161 25.4417 24.4921 25.6135 24.605C25.7852 24.7179 25.9945 24.7585 26.1961 24.7181C26.3976 24.6777 26.5751 24.5596 26.6901 24.3892C27.6986 22.851 28.1463 21.0124 27.9581 19.1827C27.7698 17.3531 26.9569 15.6442 25.6563 14.3436Z",
    fill: "#1C74D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 19.25H20.8125V16.1562C20.8125 15.949 20.7302 15.7503 20.5837 15.6038C20.4372 15.4573 20.2385 15.375 20.0312 15.375C19.824 15.375 19.6253 15.4573 19.4788 15.6038C19.3323 15.7503 19.25 15.949 19.25 16.1562V19.25H16.125C15.9178 19.25 15.7191 19.3323 15.5726 19.4788C15.4261 19.6253 15.3438 19.824 15.3438 20.0312C15.3438 20.2385 15.4261 20.4372 15.5726 20.5837C15.7191 20.7302 15.9178 20.8125 16.125 20.8125H19.25V23.9375C19.25 24.1447 19.3323 24.3434 19.4788 24.4899C19.6253 24.6364 19.824 24.7188 20.0312 24.7188C20.2385 24.7188 20.4372 24.6364 20.5837 24.4899C20.7302 24.3434 20.8125 24.1447 20.8125 23.9375V20.8125H23.9062C24.1135 20.8125 24.3122 20.7302 24.4587 20.5837C24.6052 20.4372 24.6875 20.2385 24.6875 20.0312C24.6875 19.824 24.6052 19.6253 24.4587 19.4788C24.3122 19.3323 24.1135 19.25 23.9062 19.25Z",
    fill: "#1C74D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_829_2537",
    x: 0.618896,
    y: 0.619141,
    width: 38.762,
    height: 38.7617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.454902 0 0 0 0 0.815686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_829_2537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_829_2537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_2537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/conversion.eedebe241bf99b3947eab0b8cb33deac.svg";
export { ForwardRef as ReactComponent };